import React, { useState, useContext } from 'react';
import './upload.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight, faClose, faFileCirclePlus } from '@fortawesome/free-solid-svg-icons'

import { ShareContext } from '../../context/ShareContext';
import { Link , useParams,useNavigate} from 'react-router-dom'
import BackLoader from '../../components/backloader';
import * as Constants from '../../constants';


function Upload() {
    const navigate = useNavigate()
    const {casefeeid} = useParams();

    const { setWhichUpload,whichUpload } = useContext(ShareContext)

    const [isFirstSelected, setIsFirstSelected] = useState(false);
    const [isSecondSelected, setIsSecondSelected] = useState(false);
    const [isThirdSelected, setIsThirdSelected] = useState(false);
    const [eswear, setEswear] = useState(true);


    const [openDialog, setOpenDialog] = useState(false);
    const [isLoading,setIsLoading]= useState(false);

    const firstChange = () => {
        setIsFirstSelected(!isFirstSelected)
    }

    const secondChange = () => {
        setIsSecondSelected(!isSecondSelected)
    }

    const thirdChange = () => {
        setIsThirdSelected(!isThirdSelected)
    }

    const submit = async(e) => {
        e.preventDefault();
        var ttype='';
        if (isFirstSelected) {
            setWhichUpload('attest')
            ttype='attest';
        } else if (isSecondSelected){
            setWhichUpload('not-attest')
            ttype="not-attest";
        } else if (isThirdSelected){
            setWhichUpload('template')
            ttype="template";

        }
            var data={value1:ttype};
        setIsLoading(true);
        try {
            setIsLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/gazette/documentType/${casefeeid}`, {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const responseData = await resp.json();
            setIsLoading(false);
            console.log(responseData);
            if (responseData.code === 0) {
                movePage();
            }else {
             alert('Something happen, and we cannot connect');
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
           
          }

    }

    const movePage=()=>{
        navigate(`/upload/documents/${casefeeid}`)
        
    }

  return (
    <div className='upload'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>Document Upload</h2>
                    </div>
                    <p>Your Role: Legal Counsel</p>
                </div>
                <p className="nav-status">Home/Specifications/Document-Upload-Form</p>
            </div>
            <div className="upload-questions">
                <p className="note">Please select the appropriate option by selecting the checkbox against the following items before proceeding.</p>
                <div className="questions">
                    <div className="input">
                        <input type="checkbox" id='check1' checked={isFirstSelected} onChange={firstChange}
                        disabled={isSecondSelected || isThirdSelected}/>
                        <label htmlFor="check1">I would be submitting documents that is already attested to or commissioned</label>
                    </div>
                    <div className={ isSecondSelected ? "second open" : "second"}>
                        <div className="input">
                            <input type="checkbox" id='check2' checked={isSecondSelected} onChange={secondChange} disabled={isFirstSelected || isThirdSelected}/>
                            <label htmlFor="check2">I would be submitting documents that are yet to be attested to or commissioned</label>
                        </div>
                        <div className="input inner-input">
                            <input type="checkbox" id='check2second' checked={eswear} disabled={true} />
                            <label htmlFor="check2second">I would like  the document to be commissioned through e-Swearing</label>
                        </div>
                    </div>
                    <div className="input">
                        <input type="checkbox" id='check3' checked={isThirdSelected} onChange={thirdChange}
                        disabled={isSecondSelected || isFirstSelected}/>
                        <label htmlFor="check3">I would be using available templates from JIS, creating related documents such as a writ of summons/Originating summons, amended writ of summons/originating summons, affidavit in support, written address in support, affidavit of compliance, affidavit of non-participation in a settlement, statement of intent and reason to resort to litigation, verifying affidavit further/better affidavit, etc.?</label>
                    </div>
                </div>
            </div>
            <div className="down">
                <div className="goBack" onClick={() => navigate('/categories') }>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <p>Back to Home</p>
                </div>
                <div className={ !isFirstSelected && !isSecondSelected && !isThirdSelected ? "btns inactive" : "btns"}>
                    <button 
                    className="upload" 
                    onClick={submit}
                    disabled={!isFirstSelected && !isSecondSelected && !isThirdSelected}
                    >
                        Proceed {isThirdSelected?'':' to Upload'} <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                </div>
            </div>
        </div>
     
      
        <BackLoader open={isLoading}  />
    </div>
  )
}

export default Upload